import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=535e3cbe&scoped=true"
import script from "./Youtube.vue?vue&type=script&lang=js"
export * from "./Youtube.vue?vue&type=script&lang=js"
import style0 from "./Youtube.vue?vue&type=style&index=0&id=535e3cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e3cbe",
  null
  
)

export default component.exports